import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaDiferencias from "../components/TablaDiferencias";
import { diferenciasResources } from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";
import TablaDiferenciasWalmart from "../components/TablaDiferenciasWalmart";
import { Redirect } from "react-router-dom";

class Diferencias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: [],
            totalCount: 0,
            cargando: true,
            page: 0, 
            pageSize: 25,
            search: "",
            sortField: "id",
            sortDir: "asc",
            openSnack: false,
            severity: '',
            message: '',
        };
    }

    obtenerDiferencias = () => {
        this.setState({ cargando: true, openSnack: false });
        
        diferenciasResources.getDiferencias(
            this.state.page + 1, 
            this.state.pageSize, 
            this.state.search,
            this.state.sortField,
            this.state.sortDir
        )
        .then(async response => {
            if (response) {
                return await response.json();
            }
        })
        .then(result => {
            if (result && result.status_code === 200) {
                this.setState({
                    datos: result.diferencias,
                    totalCount: result.total,
                    cargando: false
                });
            } else if (result && result.status_code === 401) {
                this.setState({
                    openSnack: true,
                    severity: result.severity,
                    message: result.message,
                    cargando: false
                });
            } else {
                throw new Error('Something went wrong ...');
            }
        })
        .catch(error => {
            console.log(error);
            this.setState({ cargando: false });
        });
    };

    componentDidMount() {    
        const verifyFolio = useToken.verifyToken();
        if (!verifyFolio) {
            this.props.history.push('/inventarios');
        } else {
            this.obtenerDiferencias();
        }
    }

    // Manejadores de cambios
    handlePageChange = (newPage) => {
        this.setState({ page: newPage }, () => this.obtenerDiferencias());
    };

    handlePageSizeChange = (newPageSize) => {
        this.setState({ pageSize: newPageSize, page: 0 }, () => this.obtenerDiferencias());
    };

    handleSearchChange = (textoBusqueda) => {
        this.setState({ search: textoBusqueda, page: 0 }, () => this.obtenerDiferencias());
    };

    handleSortChange = (field, dir) => {
        this.setState({ sortField: field, sortDir: dir, page: 0 }, () => this.obtenerDiferencias());
    };

    render() {
        let datos_inv = useToken.getDatos();
        const verifyFolio = useToken.verifyToken();

        if (!verifyFolio) {
            return <Redirect to="/inventarios"/>;
        } else {
            return (
                <div>
                    <Typography variant="h4" gutterBottom>Diferencias</Typography>
                    {datos_inv.app === 'walmart' || datos_inv.app === 'walmart_parciales' ? (
                        <TablaDiferenciasWalmart 
                            datos={this.state.datos}
                            totalCount={this.state.totalCount}
                            cargando={this.state.cargando}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            search={this.state.search}
                            sortField={this.state.sortField}
                            sortDir={this.state.sortDir}
                            onPageChange={this.handlePageChange}
                            onPageSizeChange={this.handlePageSizeChange}
                            onSearchChange={this.handleSearchChange}
                            onSortChange={this.handleSortChange}
                        />
                    ) : (
                        <TablaDiferencias datos={this.state.datos} />
                    )}
                    {this.state.openSnack ? (
                        <SnackbarAlert severity={this.state.severity} message={this.state.message}/>
                    ) : null}
                </div>
            );
        }
    }
}

export default Diferencias;